import { createFileRoute } from '@tanstack/react-router';
import { adminRoles } from '@/api/resources';
import { warm } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { RolesView } from '@/screens/admin-roles';

export const Route = createFileRoute('/admin/roles')({
  // The API's `require_capability` admits any level above `none`, so the guard's
  // minimum is `own`.
  beforeLoad: requireCapability('roles_manage', 'own'),
  loader: ({ context }) => warm(context.queryClient, adminRoles(undefined)),
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  return <RolesView setView={setView} />;
}
